import { useEffect, useState } from "react";
import { useModal } from "../../../hooks/useModal";
import { agregarDias, formatDate, notify, soloDecimal } from "../../../utils/utils";
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { Modal } from "../../components/modal/Modal";
import { MultiSelectorFecha } from "../../components/pickers/MultiSelectorFecha";
import { ContenedorParametros } from "../../components/utils/ContenedorParametros";
import { ContenedorTabla } from "../../components/utils/ContenedorTabla";
import { Tooltip } from "../../components/utils/Tooltip";
import { useGestionConocimientos } from "../../../hooks/gestionConocimientos/useGestionConocimientos";
import { DatePickerABX } from "../../components/pickers/DatePicker";

export const InventarioServidores = ()  => {
    const [ valorEstado, setValorEstado ] = useState(0);
    const [ valorPestania, setValorPestania ] = useState(0);
    const [ isOpenModalServidor, openModalServidor, closeModalServidor ] = useModal(null);
    const [ isOpenModalEliminarServidor, openModalEliminarServidor, closeModalEliminarServidor ] = useModal(null);
    const [ startDate, setStartDate ] = useState(agregarDias(-30));
    const [ endDate, setEndDate ] = useState(formatDate(new Date()));
    const [ mostrarContrasenia, setMostrarContrasenia ] = useState(false);
    const datosEliminarDefault = {
        codGestionConocimiento: 0,
        motivoEliminacion: ""
    }
    const [ datosEliminar, setDatosEliminar ] = useState(datosEliminarDefault)
    const editarValorEliminacion = (key,value) =>{
        setDatosEliminar(leccion => {
            return {
                ...leccion,
                [key]: value
            }
        })
    }
    
    const pestaniasServidores = [
        { nombre: "General", valor: 0 },
        { nombre: "Hardware", valor: 1 },
        { nombre: "IPAM", valor: 2 },
        { nombre: "Plataforma", valor: 3 },
        { nombre: "Acceso", valor: 4 }
    ]

    
    const idTabla = 'TablaDominio';
    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";

    const {
        listarEstados,
        listaEstadoConocimiento,
        listarDetalleServidor,
        detalleServidor,
        listarServidores,
        servidores,
        editarValorServidor,
        listarDistritosLima,
        listDistritosLima,
        listarAmbienteTrabajo,
        listaAmbienteTrabajo,
        listarTipoServidor,
        listaTipoServidor,
        guardarEditarServidor,
        listarSistemaOperativo,
        listaSistemaOperativo,
        listarProtocoloRemoto,
        listaProtocoloRemoto,
        eliminarServidor,
    } = useGestionConocimientos();


    const VistaGeneral = () => (
        <>
            <div className={`${valorPestania === 0 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="nomServidor">Nombre</label>
                <input
                    id="nomServidor"
                    value={detalleServidor.nomServidor}
                    onChange={(e) => editarValorServidor('nomServidor', e.target.value)}
                    className={classNameInput}
                />
                <label htmlFor="nomUbicacion">Ubicación</label>
                <select
                    id="nomUbicacion"
                    value={detalleServidor.codUbigeoDistrito}
                    onChange={(e) => editarValorServidor('codUbigeoDistrito', Number(e.target.value))} 
                    className={classNameInput}
                >
                    <option id="nomUbicacion" key={"opcionSeleccioneUbicacion"} value={0}>--Seleccione--</option>
                    {
                        listDistritosLima.length > 0 ? 
                            listDistritosLima.map(dist => (
                                <option value={dist.codUbigeoDistrito} key={dist.codUbigeoDistrito}>{dist.nomUbigeoDistrito}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="selectEntorno">Ambiente</label>
                <select
                    id="selectEntorno"
                    value={detalleServidor.codAmbienteTrabajo}
                    onChange={(e) => editarValorServidor('codAmbienteTrabajo', Number(e.target.value))}
                    className={classNameInput}
                >
                    <option value={0} key={'opcionSeleccioneEntorno'}>--Seleccione--</option>
                    {
                        listaAmbienteTrabajo.length > 0 ? 
                            listaAmbienteTrabajo.map(amb => (
                                <option key={amb.codAmbienteTrabajo} value={amb.codAmbienteTrabajo}>{amb.nomAmbienteTrabajo}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="fechaInstalacion">Fecha instalación</label>
                <DatePickerABX
                    setDate={editarValorServidor}
                    date={detalleServidor.fechaInstalacion}
                    keyDate={'fechaInstalacion'}
                    ocultarIcono={true}
                    classNameInput={`${classNameInput} w-[189px]`}
                />
                <label htmlFor="observacionServidor">Comentario</label>
                <textarea id="observacionServidor" className={`${classNameInput} h-[120px]`} onChange={(e) => editarValorServidor('comentario', e.target.value) }  value={detalleServidor.comentario}/>
            </div>
        </>
    );

    const VistaHardware = () => (
        <>
            <div className={`${valorPestania === 1 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="selectlistaTipoServidor">Tipo</label>
                <select
                    id="selectlistaTipoServidor"
                    value={detalleServidor.codTipoServidor}
                    onChange={(e) => editarValorServidor('codTipoServidor', Number(e.target.value))}
                    className={classNameInput}
                >
                    <option key={'opcionSeleccionelistaTipoServidor'} value={0}>--Seleccione--</option>
                    {
                        listaTipoServidor.length > 0 ? 
                            listaTipoServidor.map(tip => (
                                <option value={tip.codTipoServidor} key={tip.codTipoServidor}>{tip.nomTipoServidor}</option>
                            ))
                        : 
                            <></>
                    }

                </select>
                <label htmlFor="modeloServidor">Modelo servidor</label>
                <input
                    id="modeloServidor"
                    className={classNameInput}
                    value={detalleServidor.modeloServidor}
                    onChange={(e) => editarValorServidor('modeloServidor', e.target.value)}
                />
                <label htmlFor="procesador">Modelo CPU</label>
                <input
                    id="procesador"
                    className={classNameInput}
                    value={detalleServidor.modeloCPU}
                    onChange={(e) => editarValorServidor('modeloCPU', e.target.value)}
                />
                <label htmlFor="cantidadCPU"># CPUs</label>
                <input
                    id="cantidadCPU"
                    className={classNameInput}
                    value={detalleServidor.numCPU}
                    type="number"
                    onChange={(e) => editarValorServidor('numCPU', Number(e.target.value))}
                />
                <label htmlFor="cantidadRAM">RAM</label>
                <input
                    id="cantidadRAM"
                    className={classNameInput}
                    value={detalleServidor.capacidadMemoriaRAM}
                    onChange={(e) => editarValorServidor('capacidadMemoriaRAM', e.target.value)}
                    onKeyDown={(e) => soloDecimal(e, e.target)}
                />
                <label htmlFor="cantidadAlmacenamiento">Almacenamiento</label>
                <input
                    id="cantidadAlmacenamiento"
                    className={classNameInput}
                    value={detalleServidor.almacenamientoCPU}
                    type="number"
                    onChange={(e) => editarValorServidor('almacenamientoCPU', Number(e.target.value))}
                />
                <label htmlFor="tarjetaRed">Tarjeta de red</label>
                <input
                    id="tarjetaRed"
                    className={classNameInput}
                    value={detalleServidor.tarjetaRed}
                    onChange={(e) => editarValorServidor('tarjetaRed', e.target.value)}
                />
                <label htmlFor="tarjetaVideo">Tarjeta de video</label>
                <input
                    id="tarjetaVideo"
                    className={classNameInput}
                    value={detalleServidor.tarjetaVideo}
                    onChange={(e) => editarValorServidor('tarjetaVideo', e.target.value)}
                />
            </div>
        </>
    );

    const VistaAdminIP = () => (
        <>
            <div className={`${valorPestania === 2 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="red">Red</label>
                <input
                    id="red"
                    className={classNameInput}
                    value={detalleServidor.net}
                    onChange={(e) => editarValorServidor('net', e.target.value)}
                />
                <label htmlFor="subred">Subred</label>
                <input
                    id="subred"
                    className={classNameInput}
                    value={detalleServidor.subNET}
                    onChange={(e) => editarValorServidor('subNET', e.target.value)}
                />
                <label htmlFor="ipPublica">Direc. IP pública</label>
                <input
                    id="ipPublica"
                    className={classNameInput}
                    value={detalleServidor.ipPublica}
                    onChange={(e) => editarValorServidor('ipPublica', e.target.value)}
                />
                <label htmlFor="ipPrivada">Direc. IP privada</label>
                <input
                    id="ipPrivada"
                    className={classNameInput}
                    value={detalleServidor.ipPrivada}
                    onChange={(e) => editarValorServidor('ipPrivada', e.target.value)}
                />
            </div>
        </>
    );

    const VistaPlataforma = () => (
        <>
            <div className={`${valorPestania === 3 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="sistOp">Sistema operativo</label>
                <select
                    id="sistOp"
                    className={`${classNameSelect}`}
                    value={detalleServidor.codTipoOS}
                    onChange={(e) => editarValorServidor('codTipoOS', e.target.value)}
                >
                    <option key={'opcionSeleccioneSO'} value={0}>--Seleccione--</option>
                    {
                        listaSistemaOperativo.length > 0 ?
                            listaSistemaOperativo.map((sist, i) => (
                                <option key={i + '_' + sist.codTipoOS} value={sist.codTipoOS}>{sist.nomTipoOS}</option>
                            ))
                        :
                        <></>
                    }
                </select>
                <label htmlFor="distSO">Distribución SO</label>
                <input
                    id="distSO"
                    className={classNameInput}
                    value={detalleServidor.distribucion}
                    onChange={(e) => editarValorServidor('distribucion',e.target.value)}
                />
                <label htmlFor="versionSO">Versión</label>
                <input
                    id="versionSO"
                    className={classNameInput}
                    value={detalleServidor.version}
                    onChange={(e) => editarValorServidor('version',e.target.value)}
                />
                <label htmlFor="licenciaSO">Licencias</label>
                <input
                    id="licenciaSO"
                    className={classNameInput}
                    value={detalleServidor.licencia}
                    onChange={(e) => editarValorServidor('licencia',e.target.value)}
                />
            </div>
        </>
    );

    const VistaAcceso = () => (
        <>
            <div className={`${valorPestania === 4 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="urlAcceso">URL acceso</label>
                <input
                    id="urlAcceso"
                    className={classNameInput}
                    value={detalleServidor.urlAcceso}
                    onChange={(e) => editarValorServidor('urlAcceso',e.target.value)}
                />
                <label htmlFor="usuarioAcceso">Usuario acceso</label>
                <input
                    id="usuarioAcceso"
                    className={classNameInput}
                    value={detalleServidor.usuarioRoot}
                    onChange={(e) => editarValorServidor('usuarioRoot',e.target.value)}
                />
                <label htmlFor="contraAcceso">Contraseña</label>
                <div className="flex w-full gap-2 items-center">
                    <input
                        id="contraAcceso"
                        className={classNameInput + ' w-[88%]'}
                        value={detalleServidor.contrasenia}
                        onChange={(e) => editarValorServidor('contrasenia',e.target.value)}
                        type={!mostrarContrasenia ? "password" : "text"}
                    />
                    <i
                        className={`fa ${mostrarContrasenia ? 'fa-eye-slash' : 'fa-eye'} cursor-pointer`}
                        onClick={() => setMostrarContrasenia(!mostrarContrasenia)}
                    ></i>
                </div>
                <label htmlFor="puertoAcceso">Puerto acceso</label>
                <input
                    id="puertoAcceso"
                    className={classNameInput}
                    value={detalleServidor.puertoRemoto}
                    onChange={(e) => editarValorServidor('puertoRemoto',e.target.value)}
                />
                <label htmlFor="protocoloAcceso">Protocolo acceso</label>
                <select
                    id="protocoloAcceso"
                    className={classNameInput}
                    value={detalleServidor.codProtocoloRemoto}
                    onChange={(e) => editarValorServidor('codProtocoloRemoto',Number(e.target.value))}
                > 
                    <option key={'opcionSeleccioneProtocolo'} value={0}>--Seleccione--</option>
                    {
                        listaProtocoloRemoto.length > 0 ?
                            listaProtocoloRemoto.map(pro => (
                                <option key={pro.codProtocoloRemoto} value={pro.codProtocoloRemoto}>{pro.nomProtocoloRemoto}</option>
                            ))
                        :
                        <></>
                    }

                </select>
                <label htmlFor="fechaUltimaAct">F.Últ.Actualización</label>
                <DatePickerABX
                    classNameInput={` bg-zinc-900 w-[100.1%]`}
                    ocultarIcono={true}
                    date={detalleServidor.fechaUltimoMantenimiento}
                    setDate={editarValorServidor}
                    keyDate={'fechaUltimoMantenimiento'}
                />
            </div>
        </>
    );

    const seleccionarVista = () => {
        switch(valorPestania){
            case 0: return VistaGeneral();
            case 1: return VistaHardware();
            case 2: return VistaAdminIP();
            case 3: return VistaPlataforma();
            case 4: return VistaAcceso();
            default: return VistaGeneral();
        }
    };

    const registrarServidor = async () => {
        // const camposAValidar = ["nomServidor", "codUbigeoDistrito", "codlistaAmbienteTrabajo", "codTipoServidor", "comentario","numCPU", 
        //     "capacidadMemoriaRAM", "almacenamientoCPU", "net", "subNET","ipPrivada", "codTipoOS", "distribucion", "version","codProtocoloRemoto",
        //     "fechaInstalacion","fechaUltimoMantenimiento"
        // ]
        // const validarRegistro = camposAValidar.some(campo => detalleServidor[campo] === "" || detalleServidor[campo] === null || detalleServidor[campo] === 0 || detalleServidor[campo] === undefined);
        // if(validarRegistro){
        //     notify("Falta completar datos del formulario", "warning");
        //     return
        // }
        const isValid = await guardarEditarServidor();
        if(isValid){
            await listarServidores();
            closeModalServidor();
        }
    }

    const eliminar = async () => {
        const camposAValidar = ["motivoEliminacion"];
        const validarEliminacion = camposAValidar.some(campo => datosEliminar[campo] === "" || datosEliminar[campo] === null || datosEliminar[campo] === 0 || datosEliminar[campo] === undefined);
        if(validarEliminacion){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await eliminarServidor(detalleServidor.codGestionInfraestructuraServidor, datosEliminar.motivoEliminacion);
        if(isValid){
            await listarServidores();
            closeModalEliminarServidor();
        }
    }

    useEffect(() => {
        listarProtocoloRemoto();
        listarTipoServidor();
        listarAmbienteTrabajo();
        listarEstados();
        listarDistritosLima();
        listarServidores();
        listarSistemaOperativo();
    },[])

    return(
        <>
            <ContenedorParametros
                titulo='Inventario de servidores'
                tablaId={idTabla}
            >
                {/* <MultiSelectorFecha
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    identificador='InventarioServidor'
                />
                <i className="fa fa-filter" data-tip="iconoEstado" data-for="iconoEstado"></i>
                <Tooltip id={"iconoEstado"}>Estados</Tooltip>
                <select
                    id="selectEstadoDominio"
                    className={classNameSelect}
                    value={valorEstado}
                    onChange={(e) => setValorEstado(Number(e.target.value))}
                >
                    <option key={'opcionTodos_Estado'} value={0}>--Todos--</option>
                    {
                        listaEstadoConocimiento.map(e => (
                            <option key={e.codEstado} value={e.codEstado}>{e.nomEstado}</option>
                        ))
                    }
                </select> */}
                <BotonNuevo
                    onClick={async () => {
                        setMostrarContrasenia(false);
                        setValorPestania(0);
                        listarDetalleServidor();
                        openModalServidor();
                    }}
                />
                <BotonProcesar onClick={() => listarServidores()}/>
            </ContenedorParametros>
            <ContenedorTabla>
                <table id={idTabla} className="tableResponsive">
                    <thead>
                        <tr>
                            <th>N</th>
                            <th>CÓDIGO</th>
                            <th>NOMBRE</th>
                            <th>UBICACIÓN</th>
                            <th>ENTORNO</th>
                            <th>TIPO</th>
                            {/* <th># CPUs</th> */}
                            {/* <th>C. MEMORIA</th> */}
                            <th>VERSIÓN</th>
                            <th>RED</th>
                            <th>SUBRED</th>
                            <th>IP PRIVADA</th>
                            {/* <th>PROTOCOLO ACCESO</th> */}
                            <th>PUERTO</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            servidores.length > 0 ?
                                servidores.map((ser, i) => (
                                    <tr key={`fila_${i}`}>
                                        <td className="text-center">{i + 1}</td>
                                        <td className="text-center">
                                            <span className="inline-block text-center bg-blue-600 rounded px-2 w-[60px]">{ser.codigoServidor}</span>
                                        </td>
                                        <td className="w-[250px]">
                                            <div className="w-[95%] whitespace-nowrap text-ellipsis overflow-hidden">{ser.nomServidor}</div>
                                        </td>
                                        <td>{ser.localizacion}</td>
                                        <td className="text-center">{ser.ambiente}</td>
                                        <td className="text-center">{ser.nomlistaTipoServidor}</td>
                                        <td className="text-center">{ser.version}</td>
                                        <td>{ser.net}</td>
                                        <td className="text-center">{ser.subNET}</td>
                                        <td className="text-center">{ser.ipPrivada}</td>
                                        <td className="text-center">{ser.puertoRemoto}</td>
                                        <td className="text-center">
                                            <i
                                                className="fa fa-edit text-blue-600"
                                                onClick={()=> {
                                                    setMostrarContrasenia(false);
                                                    setValorPestania(0);
                                                    listarDetalleServidor(ser);
                                                    openModalServidor();
                                                }}
                                            ></i>
                                        </td>
                                        <td className="text-center">
                                            <i
                                                className="fa fa-trash text-red-600"
                                                onClick={()=> {
                                                    listarDetalleServidor(ser);
                                                    openModalEliminarServidor();
                                                }}
                                            ></i>
                                        </td>
                                    </tr>
                                ))
                            :
                                <tr>
                                    <td colSpan={16} className="text-center">No hay información para mostrar...</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>

            <Modal
                isOpen={isOpenModalServidor}
                closeModal={closeModalServidor}
                action={()=> registrarServidor()}
                title={`${detalleServidor.codGestionInfraestructuraServidor === 0 ? "Nuevo registro" : `Editar servidor [ ${detalleServidor.codigoServidor} ]`}`}
            >
                <section className="w-[700px] h-[300px] bg-zinc-800 px-2 grid grid-rows-[minmax(0,2fr)_minmax(0,8fr)]">
                    <section className="flex mx-2 gap-1 border-b-[2px] border-b-zinc-600 ">
                        {
                            pestaniasServidores.map((data, i) => (
                                <button
                                    key={'btn_' + i}
                                    className={`btnActive px-2 py-3 ${valorPestania === i ? 'border-b-[2px] ' : ''} border-blue-500`}
                                    onClick={() => setValorPestania(i)}
                                >{data.nombre}</button>
                            ))
                        }
                    </section>
                    <section className="p-2 ">
                        {
                            seleccionarVista()
                        }
                        {/* <div className={`${valorPestania === 0 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2`}>
                            <label htmlFor="codServidor">Código</label>
                            <input id="codServidor" className={classNameInput}/>
                            <label htmlFor="nomServidor">Nombre</label>
                            <input id="nomServidor" className={classNameInput}/>
                            <label htmlFor="nomUbicacion">Ubicación</label>
                            <select id="nomUbicacion" className={classNameInput}></select>
                            <label htmlFor="selectEntorno">Entorno</label>
                            <select id="selectEntorno" className={classNameInput}></select>
                            <label htmlFor="selectlistaTipoServidor">Tipo</label>
                            <select id="selectlistaTipoServidor" className={classNameInput}></select>
                        </div>
                        <div className={`${valorPestania === 1 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2`}>
                            <label htmlFor="listaTipoServidor">Tipo</label>
                            <select id="listaTipoServidor" className={classNameInput}></select>
                            <label htmlFor="modeloServidor">Modelo</label>
                            <input id="modeloServidor" className={classNameInput}/>
                            <label htmlFor="procesador">CPU</label>
                            <input id="procesador" className={classNameInput}/>
                            <label htmlFor="cantidadCPU"># CPUs</label>
                            <input id="cantidadCPU" className={classNameInput}/>
                            <label htmlFor="cantidadRAM">RAM</label>
                            <input id="cantidadRAM" className={classNameInput}/>
                            <label htmlFor="cantidadAlmacenamiento">Almacenamiento</label>
                            <input id="cantidadAlmacenamiento" className={classNameInput}/>
                            <label htmlFor="tarjetaRed">Tarjeta de red</label>
                            <input id="tarjetaRed" className={classNameInput}/>
                            <label htmlFor="tarjetaVideo">Tarjeta de video</label>
                            <input id="tarjetaVideo" className={classNameInput}/>
                        </div>
                        <div className={`${valorPestania === 2 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2`}>
                            <label htmlFor="red">Red</label>
                            <input id="red" className={classNameInput}/>
                            <label htmlFor="subred">Subred</label>
                            <input id="subred" className={classNameInput}/>
                            <label htmlFor="ipPublica">Direc. IP pública</label>
                            <input id="ipPublica" className={classNameInput}/>
                            <label htmlFor="ipPrivada">Direc. IP privada</label>
                            <input id="ipPrivada" className={classNameInput}/>
                        </div>
                        <div className={`${valorPestania === 3 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2`}>
                            <label htmlFor="sistOp">Sistema operativo</label>
                            <input id="sistOp" className={classNameInput}/>
                            <label htmlFor="distSO">Distribución SO</label>
                            <input id="distSO" className={classNameInput}/>
                            <label htmlFor="versionSO">Versión</label>
                            <input id="versionSO" className={classNameInput}/>
                            <label htmlFor="licenciaSO">Licencias</label>
                            <input id="licenciaSO" className={classNameInput}/>
                        </div>
                        <div className={`${valorPestania === 4 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2`}>
                            <label htmlFor="urlAcceso">URL acceso</label>
                            <input id="urlAcceso" className={classNameInput}/>
                            <label htmlFor="usuarioAcceso">Usuario acceso</label>
                            <input id="usuarioAcceso" className={classNameInput}/>
                            <label htmlFor="contraAcceso">Contraseña acceso</label>
                            <input id="contraAcceso" className={classNameInput}/>
                            <label htmlFor="puertoAcceso">Puerto acceso</label>
                            <input id="puertoAcceso" className={classNameInput}/>
                            <label htmlFor="protocoloAcceso">Protocolo acceso</label>
                            <input id="protocoloAcceso" className={classNameInput}/>
                        </div> */}
                    </section>
                </section>
            </Modal>
            {/* MODAL PARA ELIMINAR LECCIÓN Y APRENDIZAJE */}
            <Modal
                isOpen={isOpenModalEliminarServidor}
                closeModal={closeModalEliminarServidor}
                action={() => eliminar()}
                title={`Eliminar Servidor [${detalleServidor.codGestionInfraestructuraServidor}]`}
                textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
            >
                <div className='grid gap-2 py-3 w-[350px]'>
                    <strong className="">Motivo:</strong>
                    <textarea
                        className={`${classNameInput}
                        h-[80px] resize-none`}
                        placeholder="Escriba aquí el motivo de la eliminación de leccion y aprendizaje..."
                        onChange={(e) => editarValorEliminacion('motivoEliminacion', e.target.value)}
                    />
                </div>
            </Modal>
        </>
    )
}